import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route as RouterRoute } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import TicketsV2 from "../pages/TicketsV2";
import ConversasV2 from "../pages/ConversasV2";
import Signup from "../pages/Signup";
import Login from "../pages/Login";
import Connections from "../pages/Connections";
import SettingsCustom from "../pages/SettingsCustom";
import Financeiro from "../pages/Financeiro";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments";
import Queues from "../pages/Queues";
import Tags from "../pages/Tags";
import MessagesAPI from "../pages/MessagesAPI";
import Helps from "../pages/Helps";
import ContactLists from "../pages/ContactLists";
import ContactListItems from "../pages/ContactListItems";
import Companies from "../pages/Companies";
import Opportunities from "../pages/Opportunities";
import KoraxFormPublic from "../pages/KoraxFormPublic";
import KoraxFormsAdminGate from "../pages/KoraxForms/KoraxFormsAdminGate";
import { MasterProspectionPage } from "../components/ProspectionMasterGate";
import LocalDiagnostic from "../pages/LocalDiagnostic";
import DigitalDiagnostic from "../pages/DigitalDiagnostic";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Agenda from "../pages/Agenda";
import Catalog from "../pages/Catalog";
import ServiceOrders from "../pages/ServiceOrders";
import PublicCatalog from "../pages/PublicCatalog";
import Campaigns from "../pages/Campaigns";
import Disparos from "../pages/Disparos";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AllConnections from "../pages/AllConnections";
import Reports from "../pages/Reports";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
// import Integrations from '../pages/Integrations';
// import GoogleCalendarComponent from '../pages/Integrations/components/GoogleCalendarComponent';
import FlowBuilder from "../pages/FlowBuilder";
import CampaignsPhrase from "../pages/CampaignsPhrase";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files";
import ToDoList from "../pages/ToDoList";
import Kanban from "../pages/Kanban";
import CavIALibrary from "../pages/CavIALibrary";
import CavIABuilder from "../pages/CavIABuilder";
import AICreditsPage from "../pages/AICredits";
import AICreditsAdmin from "../pages/AICreditsAdmin";
import DashboardMaster from "../pages/DashboardMaster";
import DashboardMasterCompany from "../pages/DashboardMasterCompany";
import DashboardMasterPlans from "../pages/DashboardMasterPlans";
import DashboardMasterAcquisition from "../pages/DashboardMasterAcquisition";
import MessageSequences from "../pages/MessageSequences";
import QuickMessages from "../pages/QuickMessages";
import PaymentSuccess from "../pages/PaymentSuccess";
import CreatePassword from "../pages/CreatePassword";
import Onboarding from "../pages/Onboarding";
import TagsKanban from "../pages/TagsKanban";
import ForgotPassword from "../pages/ForgetPassWord";
import ResetPassword from "../pages/ResetPassword";

// 🔹 NOVO: página de Configurações Globais (Mercado Pago + SMTP)
import GlobalConfig from "../pages/GlobalConfig";
import ServerMetrics from "../pages/ServerMetrics";
import EmailBeta from "../pages/EmailBeta";
import KoraxSign from "../pages/KoraxSign";
import KoraxSignEditor from "../pages/KoraxSignEditor";
import KoraxSignDocumentWorkspace from "../pages/KoraxSignDocumentWorkspace";
import KoraxSignPublic from "../pages/KoraxSignPublic";

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(true);
useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <Switch>
            <RouterRoute
              exact
              path="/diagnostico"
              component={DigitalDiagnostic}
            />
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <Route exact path="/catalogo/:companyId" component={PublicCatalog} />
            <Route exact path="/s" component={KoraxSignPublic} />
            <Route exact path="/sign" component={KoraxSignPublic} />
            <Route exact path="/sign/:token" component={KoraxSignPublic} />
            <RouterRoute exact path="/f/:token" component={KoraxFormPublic} />
            <RouterRoute exact path="/forms/f/:publicId/:token" component={KoraxFormPublic} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/financeiro" component={Financeiro} isPrivate />
                <Route exact path="/opportunities" component={Opportunities} isPrivate />
                <Route exact path="/crm" component={Opportunities} isPrivate />
                <Route exact path="/formularios" component={KoraxFormsAdminGate} isPrivate />
                <Route exact path="/prospeccao" component={MasterProspectionPage} isPrivate />
                <Route
                  exact
                  path="/diagnostico-local"
                  component={LocalDiagnostic}
                  isPrivate
                />

                <Route exact path="/companies" component={Companies} isPrivate />
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/dashboard-antigo" component={Dashboard} isPrivate />
                <Route exact path="/operations" component={Dashboard} isPrivate />

                <Route exact path="/ai-credits" component={AICreditsPage} isPrivate />
                <Route exact path="/pagamento-sucesso" component={PaymentSuccess} />
                <Route exact path="/criar-senha" component={CreatePassword} />
                <Route exact path="/ai-credits-admin" component={AICreditsAdmin} isPrivate />
                <Route exact path="/dashboard-master" component={DashboardMaster} isPrivate />
                <Route
                  exact
                  path="/dashboard-master/plans"
                  component={DashboardMasterPlans}
                  isPrivate
                />
                <Route
                  exact
                  path="/dashboard-master/companies/:companyId"
                  component={DashboardMasterCompany}
                  isPrivate
                />
                <Route
                  exact
                  path="/dashboard-master/acquisition"
                  component={DashboardMasterAcquisition}
                  isPrivate
                />
          <Route exact path="/onboarding" component={Onboarding} isPrivate />
                <Route exact path="/message-sequences" component={MessageSequences} isPrivate />
                <Route exact path="/quick-messages" component={QuickMessages} isPrivate />
                <Route exact path="/korax-ia/biblioteca" component={CavIALibrary} isPrivate />
                <Route exact path="/korax-ia/treinamento" component={CavIABuilder} isPrivate />
                <Route exact path="/korax-ia/treinamento/:promptId" component={CavIABuilder} isPrivate />
                <Route exact path="/tickets" component={TicketResponsiveContainer} isPrivate />
                <Route exact path="/tickets/:ticketId" component={TicketResponsiveContainer} isPrivate />
                <Route exact path="/tickets-v2" component={TicketsV2} isPrivate />
                <Route exact path="/conversas-v2" component={ConversasV2} isPrivate />
<Route exact path="/todolist" component={ToDoList} isPrivate />
                <Route exact path="/schedules" component={Schedules} isPrivate />
                <Route exact path="/agenda" component={Agenda} isPrivate />
                <Route exact path="/catalog" component={Catalog} isPrivate />
                <Route exact path="/service-orders" component={ServiceOrders} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route
                  exact
                  path="/contacts/import"
                  component={ContactImportPage}
                  isPrivate
                />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route
                  exact
                  path="/messages-api"
                  component={MessagesAPI}
                  isPrivate
                />
                <Route
                  exact
                  path="/settings"
                  component={SettingsCustom}
                  isPrivate
                />

                {/* 🔹 NOVO: rota para Configurações Globais da plataforma */}
                <Route
                  exact
                  path="/global-config"
                  component={GlobalConfig}
                  isPrivate
                />

                <Route
                  exact
                  path="/email"
                  component={EmailBeta}
                  isPrivate
                />
                <Route
                  exact
                  path="/documents"
                  component={KoraxSign}
                  isPrivate
                />
                <Route
                  exact
                  path="/documents/:id"
                  component={KoraxSignDocumentWorkspace}
                  isPrivate
                />
                <Route
                  exact
                  path="/server-metrics"
                  component={ServerMetrics}
                  isPrivate
                />

                <Route exact path="/queues" component={Queues} isPrivate />
                <Route exact path="/reports" component={Reports} isPrivate />
                <Route
                  exact
                  path="/queue-integration"
                  component={QueueIntegration}
                  isPrivate
                />
                <Route
                  exact
                  path="/announcements"
                  component={Annoucements}
                  isPrivate
                />
                <Route
                  exact
                  path="/phrase-lists"
                  component={CampaignsPhrase}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilders"
                  component={FlowBuilder}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilder/:id?"
                  component={FlowBuilderConfig}
                  isPrivate
                />
                <Route exact path="/chats/:id?" component={Chat} isPrivate />
                <Route exact path="/files" component={Files} isPrivate />
                <Route exact path="/moments" component={ChatMoments} isPrivate />
                <Route exact path="/Kanban" component={Kanban} isPrivate />
                <Route exact path="/TagsKanban" component={TagsKanban} isPrivate />
                <Route exact path="/prompts" component={Prompts} isPrivate />
                <Route
                  exact
                  path="/allConnections"
                  component={AllConnections}
                  isPrivate
                />
                <Route
                  exact
                  path="/connections"
                  component={Connections}
                  isPrivate
                />
                {showCampaigns && (
                  <>
                    <Route
                      exact
                      path="/contact-lists"
                      component={ContactLists}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/contact-lists/:contactListId/contacts"
                      component={ContactListItems}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/disparos" component={Disparos} isPrivate />
                <Route exact
                      path="/disparos/listas"
                      component={Disparos} isPrivate />
                <Route exact
                      path="/disparos/config"
                      component={Disparos} isPrivate />
                <Route exact path="/campaigns"
                      component={Campaigns}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaign/:campaignId/report"
                      component={CampaignReport}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaigns-config"
                      component={CampaignsConfig}
                      isPrivate
                    />
                  </>
                )}
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer position="top-center" autoClose={3000} />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
